import React from 'react';
import { Mail, MessageSquare, Phone, Share2, Send } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';
const ChannelsSection = () => {
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-white relative overflow-hidden" data-id="element-118">
      {/* Background decorative elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-[#EDE8F5]/20 to-white" data-id="element-119"></div>
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-to-br from-[#7091E6]/5 to-transparent rounded-full filter blur-3xl" data-id="element-120"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-gradient-to-tr from-[#3D52A0]/5 to-transparent rounded-full filter blur-3xl" data-id="element-121"></div>
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-122">
        <ScrollReveal data-id="element-123">
          <div className="text-center mb-16" data-id="element-124">
            <span className="inline-block px-4 py-1 bg-[#3D52A0]/10 rounded-full text-sm font-medium text-[#3D52A0] mb-6" data-id="element-125">
              Multi-Channel Communication
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-[#3D52A0] mb-6" data-id="element-126">
              One tool,{' '}
              <span className="bg-gradient-to-r from-[#3D52A0] to-[#7091E6] text-transparent bg-clip-text" data-id="element-127">
                all communication channels
              </span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#3D52A0] to-[#7091E6] rounded-full mx-auto mb-6" data-id="element-128"></div>
            <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-129">
              Shepherd Flow AI generates ready-to-send messages across every
              platform your church uses to connect with people.
            </p>
          </div>
        </ScrollReveal>
        {/* Communication channels showcase */}
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12" data-id="element-130">
          <ScrollReveal delay={100} data-id="element-131">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 h-full flex flex-col transform hover:-translate-y-1 hover:border-[#3D52A0]/20" data-id="element-132">
              <div className="bg-gradient-to-r from-[#3D52A0] to-[#7091E6] p-4 flex justify-center" data-id="element-133">
                <Mail className="text-white h-8 w-8" data-id="element-134" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-135">
                <h3 className="font-semibold text-lg text-[#3D52A0] mb-2" data-id="element-136">
                  Compelling Email Copy
                </h3>
                <div className="bg-gray-50 rounded-lg p-4 mt-3 flex-1 border border-gray-100" data-id="element-137">
                  <div className="mb-2" data-id="element-138">
                    <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-139"></div>
                    <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-140"></div>
                  </div>
                  <div className="space-y-2 mt-4" data-id="element-141">
                    <div className="h-2 bg-gray-200 rounded w-full" data-id="element-142"></div>
                    <div className="h-2 bg-gray-200 rounded w-5/6" data-id="element-143"></div>
                    <div className="h-2 bg-gray-200 rounded w-4/6" data-id="element-144"></div>
                    <div className="h-2 bg-gray-200 rounded w-full" data-id="element-145"></div>
                    <div className="h-2 bg-gray-200 rounded w-3/4" data-id="element-146"></div>
                  </div>
                  <div className="mt-5 flex justify-center" data-id="element-147">
                    <div className="h-6 w-20 bg-[#3D52A0] rounded" data-id="element-148"></div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-4" data-id="element-149">
                  Beautiful, engaging emails that drive action and attendance
                </p>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={200} data-id="element-150">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 h-full flex flex-col transform hover:-translate-y-1 hover:border-[#3D52A0]/20" data-id="element-151">
              <div className="bg-gradient-to-r from-[#3D52A0] to-[#7091E6] p-4 flex justify-center" data-id="element-152">
                <MessageSquare className="text-white h-8 w-8" data-id="element-153" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-154">
                <h3 className="font-semibold text-lg text-[#3D52A0] mb-2" data-id="element-155">
                  Personal Text Messages
                </h3>
                <div className="bg-gray-50 rounded-lg p-4 mt-3 flex-1 border border-gray-100" data-id="element-156">
                  <div className="flex flex-col gap-3" data-id="element-157">
                    <div className="self-start bg-gray-200 rounded-lg p-2 max-w-[80%]" data-id="element-158">
                      <div className="h-2 bg-gray-300 rounded w-24 mb-1" data-id="element-159"></div>
                      <div className="h-2 bg-gray-300 rounded w-32" data-id="element-160"></div>
                    </div>
                    <div className="self-end bg-[#3D52A0]/20 rounded-lg p-2 max-w-[80%]" data-id="element-161">
                      <div className="h-2 bg-[#3D52A0]/30 rounded w-28 mb-1" data-id="element-162"></div>
                      <div className="h-2 bg-[#3D52A0]/30 rounded w-20" data-id="element-163"></div>
                    </div>
                    <div className="self-start bg-gray-200 rounded-lg p-2 max-w-[80%]" data-id="element-164">
                      <div className="h-2 bg-gray-300 rounded w-36 mb-1" data-id="element-165"></div>
                      <div className="h-2 bg-gray-300 rounded w-24" data-id="element-166"></div>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-4" data-id="element-167">
                  Concise, personal texts with high open rates (98%)
                </p>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={300} data-id="element-168">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 h-full flex flex-col transform hover:-translate-y-1 hover:border-[#3D52A0]/20" data-id="element-169">
              <div className="bg-gradient-to-r from-[#3D52A0] to-[#7091E6] p-4 flex justify-center" data-id="element-170">
                <Phone className="text-white h-8 w-8" data-id="element-171" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-172">
                <h3 className="font-semibold text-lg text-[#3D52A0] mb-2" data-id="element-173">
                  Friendly Voicemail Scripts
                </h3>
                <div className="bg-gray-50 rounded-lg p-4 mt-3 flex-1 border border-gray-100" data-id="element-174">
                  <div className="flex justify-center mb-3" data-id="element-175">
                    <div className="h-10 w-10 bg-gray-300 rounded-full flex items-center justify-center" data-id="element-176">
                      <div className="h-5 w-5 bg-white rounded-full" data-id="element-177"></div>
                    </div>
                  </div>
                  <div className="space-y-1 mt-3" data-id="element-178">
                    <div className="h-1 bg-gray-300 rounded w-full" data-id="element-179"></div>
                    <div className="h-1 bg-gray-300 rounded w-full" data-id="element-180"></div>
                    <div className="h-1 bg-gray-300 rounded w-4/5" data-id="element-181"></div>
                    <div className="h-1 bg-gray-300 rounded w-3/5" data-id="element-182"></div>
                    <div className="h-1 bg-gray-300 rounded w-full" data-id="element-183"></div>
                    <div className="h-1 bg-gray-300 rounded w-2/3" data-id="element-184"></div>
                    <div className="h-1 bg-gray-300 rounded w-3/4" data-id="element-185"></div>
                    <div className="h-1 bg-gray-300 rounded w-full" data-id="element-186"></div>
                  </div>
                  <div className="mt-3 flex justify-center" data-id="element-187">
                    <div className="h-4 w-4 bg-gray-300 rounded-full" data-id="element-188"></div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-4" data-id="element-189">
                  Warm, inviting voicemail scripts that feel personal
                </p>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={400} data-id="element-190">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 h-full flex flex-col transform hover:-translate-y-1 hover:border-[#3D52A0]/20" data-id="element-191">
              <div className="bg-gradient-to-r from-[#3D52A0] to-[#7091E6] p-4 flex justify-center" data-id="element-192">
                <Share2 className="text-white h-8 w-8" data-id="element-193" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-194">
                <h3 className="font-semibold text-lg text-[#3D52A0] mb-2" data-id="element-195">
                  Engaging Social Posts
                </h3>
                <div className="bg-gray-50 rounded-lg p-4 mt-3 flex-1 border border-gray-100" data-id="element-196">
                  <div className="h-20 bg-gray-200 rounded-lg mb-3" data-id="element-197"></div>
                  <div className="space-y-2" data-id="element-198">
                    <div className="h-2 bg-gray-200 rounded w-full" data-id="element-199"></div>
                    <div className="h-2 bg-gray-200 rounded w-4/5" data-id="element-200"></div>
                  </div>
                  <div className="mt-3 flex justify-between" data-id="element-201">
                    <div className="h-4 w-4 bg-gray-300 rounded-full" data-id="element-202"></div>
                    <div className="h-4 w-4 bg-gray-300 rounded-full" data-id="element-203"></div>
                    <div className="h-4 w-4 bg-gray-300 rounded-full" data-id="element-204"></div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-4" data-id="element-205">
                  Eye-catching content for all social platforms
                </p>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={500} data-id="element-206">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 h-full flex flex-col transform hover:-translate-y-1 hover:border-[#3D52A0]/20" data-id="element-207">
              <div className="bg-gradient-to-r from-[#3D52A0] to-[#7091E6] p-4 flex justify-center" data-id="element-208">
                <Send className="text-white h-8 w-8" data-id="element-209" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-210">
                <h3 className="font-semibold text-lg text-[#3D52A0] mb-2" data-id="element-211">
                  Beautiful Postcards
                </h3>
                <div className="bg-gray-50 rounded-lg p-4 mt-3 flex-1 border border-gray-100" data-id="element-212">
                  <div className="h-24 bg-gray-200 rounded-lg mb-2 flex items-center justify-center" data-id="element-213">
                    <div className="w-12 h-12 bg-white/50 rounded-full flex items-center justify-center" data-id="element-214">
                      <div className="w-8 h-8 bg-white/80 rounded-full" data-id="element-215"></div>
                    </div>
                  </div>
                  <div className="mt-2" data-id="element-216">
                    <div className="h-2 bg-gray-300 rounded w-full mb-1" data-id="element-217"></div>
                    <div className="h-2 bg-gray-300 rounded w-2/3" data-id="element-218"></div>
                  </div>
                  <div className="mt-2 flex justify-end" data-id="element-219">
                    <div className="h-6 w-6 bg-gray-300 rounded" data-id="element-220"></div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-4" data-id="element-221">
                  Physical reminders that stand out in mailboxes
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>
        {/* Bottom message */}
        <ScrollReveal delay={600} data-id="element-222">
          <div className="bg-gradient-to-r from-[#3D52A0]/5 to-[#7091E6]/5 p-8 rounded-xl border border-[#3D52A0]/10 mt-12" data-id="element-223">
            <div className="flex items-center justify-center mb-6" data-id="element-224">
              <div className="h-1 bg-gradient-to-r from-[#3D52A0] to-[#7091E6] w-24 rounded-full" data-id="element-225"></div>
            </div>
            <p className="text-center text-lg text-[#3D52A0] font-medium" data-id="element-226">
              "All messages are automatically customized to match your church's
              unique voice, branding, and communication style."
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>;
};
export default ChannelsSection;